import Confetti from "react-confetti";

import { useViewport } from "../../Contexts/ViewportContext";

import { UnclaimedPageBackground } from "../../Assets/Images";

export default function UnclaimedBackground() {
  const { width, height } = useViewport();

  return (
    <div className="unclaimed-background">
      <UnclaimedPageBackground className="unclaimed-background-image" />
      <div className="unclaimed-background-filter"></div>
      <Confetti width={width} height={height} />
      <div className="unclaimed-green-layer"></div>
    </div>
  );
}
